var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('vue-apex-charts',{attrs:{"type":"line","height":"300","options":_vm.chartOptions,"series":_vm.series},on:{"click":_vm.clickHandler}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }